<template>
  <div class="my_team">
    <div class="team_head">
      <div class="rank"><i class="icon_rank" :class="'top' + myTeamRank.teamRank">{{myTeamRank.teamRank}}</i></div>
      <div class="info">
        <div class="name">{{myTeamRank.teamName}}</div>
        <div class="value">战力值：{{myTeamRank.teamPower}}</div>
      </div>
      <div class="detail"><button type="button" @click="recordDetail('TEAM', myTeamRank.teamNo)">查看战绩</button></div>
    </div>
    <div class="team_member" :class="{isCaptain: isCaptain}">
      <div class="title">战队成员</div>
      <div class="item" v-for="(item, index) in myTeamMember" :key="index">
        <div class="photo">
          <img :src="item.avatar && item.avatar.length > 0 ? item.avatar : picUrl.defaultImage">
          <span v-if="item.roleType === 'QUEUE'" class="queue">队长</span>
        </div>
        <div class="info">
          <div class="name">{{item.teamMemberName}} {{item.teamMemberPhone}}</div>
          <div class="value">战力值：{{item.power}}</div>
          <div class="time">加入时间：{{item.joinTime}}</div>
        </div>
        <div class="detail"><button type="button" @click="recordDetail('PERSONAL', item.memberId)">查看战绩</button></div>
      </div>
    </div>
    <div class="btn_bottom" v-if="isCaptain"><!-- 只有队长才能招募 -->
      <button type="button" @click="recruit"><i class="icon-wx"></i>招募队友</button>
    </div>
    <!--遮罩-->
    <div v-if="showRecord || showRecruit" class="mask" @click="showRecord = false; showRecruit = false"></div>
    <!--邀请战友提示-->
    <div v-if="showRecruit" class="recruitTips"><img :src="picUrl.recruitTips"></div>
    <!--查看战绩-->
    <div v-if="showRecord" class="record">
      <div class="close" @click="showRecord = false"><img :src="picUrl.closeImage"></div>
      <div class="title">查看战绩</div>
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__bd">传播阅读</div>
          <div class="weui-cell__ft">{{gradeDetail.spreadReadQty}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">传播报名</div>
          <div class="weui-cell__ft">{{gradeDetail.spreadApplyQty}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">传播开单数</div>
          <div class="weui-cell__ft">{{gradeDetail.spreadOrderQty}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">传播开单金额</div>
          <div class="weui-cell__ft">￥{{gradeDetail.spreadOrderAmount}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">招募星客数</div>
          <div class="weui-cell__ft">{{gradeDetail.recruitStarGuestQty}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">裂变阅读</div>
          <div class="weui-cell__ft">{{gradeDetail.fissionReadQty}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">裂变报名</div>
          <div class="weui-cell__ft">{{gradeDetail.fissionApplyQty}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">裂变开单数</div>
          <div class="weui-cell__ft">{{gradeDetail.fissionOrderQty}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">裂变开单金额</div>
          <div class="weui-cell__ft">￥{{gradeDetail.fissionOrderAmount}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">裂变招募星客数</div>
          <div class="weui-cell__ft">{{gradeDetail.fissionRecruitStarGuestQty}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { floatMul, formatCurrency, jsonDateFormat } from '@/utils/index.js'
export default {
  name: 'my-team',
  data () {
    return {
      picUrl: {
        defaultImage: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/cimen/share.png',
        closeImage: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/close.png',
        recruitTips: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/recruitTips.png'
      },
      showRecord: false, // 显示战绩
      showRecruit: false, // 招募队友提示
      popularizeNo: '',
      myTeamRank: { // 我的战队排行信息
        teamCount: 0, // 战队人数
        teamName: '', // 战队名称
        teamNo: '', // 战队编号
        teamPower: 0, // 战队战力
        teamRank: 0 // 战队排名
      },
      myTeamMember: [], // 战队成员
      gradeDetail: {
        fissionApplyQty: 0, // 裂变报名数
        fissionOrderAmount: 0, // 裂变开单金额
        fissionOrderQty: 0, // 裂变开单数
        fissionReadQty: 0, // 裂变阅读
        fissionRecruitStarGuestQty: 0, // 裂变招募星客数
        recruitStarGuestQty: 0, // 招募星客数
        spreadApplyQty: 0, // 传播报名
        spreadOrderAmount: 0, // 传播开单金额
        spreadOrderQty: 0, // 传播开单数
        spreadReadQty: 0 // 传播阅读
      },
      accountData: { // 个人信息
        nickName: '', // 昵称
        mobile: '' // 手机号
      }
    }
  },
  computed: {
    isCaptain () { // 本人是不是队长
      let self = this
      let roleType = ''
      self.myTeamMember.forEach(item => {
        if (self.accountData.mobile === item.teamMemberPhone) {
          roleType = item.roleType
        }
      })
      if (roleType === 'QUEUE') { // QUEUE队长
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    isCaptain (val) {
      if (val) { // 队长才能分享
        this.wxShare()
      }
    }
  },
  activated () {
    this.popularizeNo = this.$route.query.popularizeNo
    this.myTeamRank = { // 我的战队排行信息
      teamCount: 0, // 战队人数
      teamName: '', // 战队名称
      teamNo: '', // 战队编号
      teamPower: 0, // 战队战力
      teamRank: 0 // 战队排名
    }
    this.myTeamMember = [] // 战队成员
    this.gradeDetail = {
      fissionApplyQty: 0, // 裂变报名数
      fissionOrderAmount: 0, // 裂变开单金额
      fissionOrderQty: 0, // 裂变开单数
      fissionReadQty: 0, // 裂变阅读
      fissionRecruitStarGuestQty: 0, // 裂变招募星客数
      recruitStarGuestQty: 0, // 招募星客数
      spreadApplyQty: 0, // 传播报名
      spreadOrderAmount: 0, // 传播开单金额
      spreadOrderQty: 0, // 传播开单数
      spreadReadQty: 0 // 传播阅读
    }
    this.accountData = { // 个人信息
      nickName: '', // 昵称
      mobile: '' // 手机号
    }
    this.getMyAccount()
  },
  methods: {
    /**
     * /h5/star/alliance2/star/guest/account/total/obtain/my/account
     * 总的个人账户信息
     */
    getMyAccount () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            self.accountData = res.data
            self.getMyTeamRank()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/task/my/team/rank
     * 我的战队排行信息
     */
    getMyTeamRank () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/my/team/rank',
          params: {
            popularizeNo: self.popularizeNo
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              res.data.teamPower = floatMul(res.data.teamPower, 100)
              self.myTeamRank = res.data
              self.getTeamMember()
            } else {
              self.$weui.toast('您当前暂无战队信息', {
                duration: 2000,
                className: 'toast_text'
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/task/team/my/member/detail
     * 我的战队成员列表
     */
    getTeamMember () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/team/my/member/detail',
          params: {
            popularizeNo: self.popularizeNo,
            teamNo: self.myTeamRank.teamNo,
            pageNo: 1,
            pageSize: 999
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              res.data.list.forEach(item => {
                item.power = floatMul(item.power, 100) // 战力值 = 实际值 * 100
                item.joinTime = jsonDateFormat(item.joinTime, 'date')
              })
              self.myTeamMember = res.data.list
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    recordDetail (gradeObjType, gradeObjId) { // 查看战绩
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/team/my/grade/detail',
          params: {
            gradeObjType: gradeObjType,
            gradeObjId: gradeObjId,
            popularizeNo: self.popularizeNo
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              res.data.spreadOrderAmount = formatCurrency(res.data.spreadOrderAmount)
              res.data.fissionOrderAmount = formatCurrency(res.data.fissionOrderAmount)
              self.gradeDetail = res.data
              this.showRecord = true
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    recruit () { // 招募队友
      this.showRecruit = true
    },
    wxShare () {
      let self = this
      let shareUrl = document.location.protocol + '//' + location.host + '/index.html#/joinTeam?sourceType=STAR_GUEST' + '&sourceNo=' + localStorage.getItem('share_saleOrgNo') + '&activityId=' + localStorage.getItem('activityId') + '&clerkId=' + localStorage.getItem('share_clerkId') + '&popularizeNo=' + self.popularizeNo + '&teamNo=' + self.myTeamRank.teamNo
      let shareTitle = self.accountData.nickName + '邀请您加入他的星客联盟战队'
      let shareText = '加入' + self.myTeamRank.teamName + '战队一起来挑战，快来加入吧！'
      let shareImage = self.$store.state.ossLink + 'logo.png'
      self.$fly
        .request({
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'hideMenuItems',
                'showMenuItems',
                'onMenuShareTimeline',
                'onMenuShareAppMessage'
              ]
            })
            self.$wx.ready(function () {
              self.$wx.hideAllNonBaseMenuItem()
              self.$wx.showMenuItems({
                menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
              })
              self.$wx.updateAppMessageShareData({
                title: shareTitle, // 分享标题
                desc: shareText, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                },
                fail: function () {
                  self.$wx.onMenuShareAppMessage({
                    title: shareTitle, // 分享标题
                    desc: shareText, // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareImage, // 分享图标
                    success: function () {
                      // 设置成功
                    },
                    fail: function () {
                      window.location.reload()
                    }
                  })
                }
              })
              self.$wx.updateTimelineShareData({
                title: shareTitle, // 分享标题
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
              self.$wx.onMenuShareTimeline({
                title: shareTitle, // 分享标题
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 用户点击了分享后执行的回调函数
                }
              })
              self.$wx.onMenuShareAppMessage({
                title: shareTitle, // 分享标题
                desc: shareText, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="less">
.my_team{
  .team_head{
    display: flex;
    background: #fefcf2;
    padding-bottom: 40px;
    .rank{
      width: 60px;
      padding: 35px 0 0 20px;
      .icon_rank{
        display: block;
        width: 60px;
        height: 60px;
        line-height: 60px;
        color: #7c4d1f;
        text-align: center;
        font-size: 24px;
        font-style: normal;
        font-weight: bold;
        background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-rank-gray.png');
        background-repeat: no-repeat;
        background-position: center center;
        -webkit-background-size: cover;
        background-size: cover;
      }
      .icon_rank.top1{
        background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-rank-top1.png');
      }
      .icon_rank.top2{
        background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-rank-top2.png');
      }
      .icon_rank.top3{
        background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-rank-top3.png');
      }
    }
    .info{
      padding: 35px 15px 0;
      flex: 1;
      .name{
        line-height: 38px;
        color: #7c4d1f;
        font-weight: bold;
        font-size: 28px;
      }
      .value{
        line-height: 34px;
        color: #bf804e;
        font-size: 26px;
      }
    }
    .detail{
      width: 152px;
      padding: 40px 20px 0 0;
      button{
        width: 152px;
        height: 60px;
        color: #fb4e2d;
        border: solid 2px #fb4e2d;
        border-radius: 60px;
        box-sizing: border-box;
        background: #fefcf2;
      }
    }
  }
  .team_member{
    background: #fff;
    .title{
      height: 86px;
      line-height: 86px;
      border-bottom: solid 1px #f0f0f0;
      color: #7c4d1f;
      font-weight: bold;
      padding: 0 22px;
    }
    .item{
      padding: 0 20px 35px;
      border-bottom: solid 1px #f0f0f0;
      display: flex;
      .photo{
        width: 66px;
        height: 66px;
        padding-top: 37px;
        position: relative;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        span{
          position: absolute;
          left: 0;
          bottom: -35px;
          display: block;
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 24px;
          text-align: center;
          color: #fff;
          background: #fb4e2d;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
        }
      }
      .info{
        padding: 35px 15px 0;
        flex: 1;
        .name{
          line-height: 38px;
          color: #7c4d1f;
          font-weight: bold;
          font-size: 28px;
        }
        .value,
        .time{
          line-height: 34px;
          color: #bf804e;
          font-size: 26px;
        }
      }
      .detail{
        width: 152px;
        padding: 40px 0 0;
        button{
          width: 152px;
          height: 60px;
          color: #fb4e2d;
          border: solid 2px #fb4e2d;
          border-radius: 60px;
          box-sizing: border-box;
          background: #fefcf2;
        }
      }
    }
  }
  .isCaptain{
    padding-bottom: 120px;
  }
  .btn_bottom{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 120px;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    button{
      width: 100%;
      height: 100%;
      background: #fb4e2d;
      border: none;
      color: #fff;
      font-size: 28px;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      border-radius: 10px;
      .icon-wx{
        display: inline-block;
        width: 35px;
        height: 35px;
        margin-right: 5px;
        background: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-wx-white.png') no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        vertical-align: top;
      }
    }
  }
  .mask{
    position: fixed;
    left: 0;
    top: 0;
    display: block;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.6);
    z-index: 998;
  }
  .recruitTips{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    img{
      width: 100%;
    }
  }
  .record{
    position: fixed;
    left: 50%;
    top: 50%;
    width: 540px;
    height: 827px;
    margin: -413px 0 0 -270px;
    background: #fff;
    border-radius: 10px;
    z-index: 999;
    .close{
      position: absolute;
      right: 18px;
      top: 18px;
      img{
        width: 28px;
        height: 28px;
      }
    }
    .title{
      height: 102px;
      line-height: 102px;
      text-align: center;
      font-size: 32px;
    }
    .weui-cells{
      height: calc(100% - 102px);
      margin: 0;
      overflow-y: auto;
      background: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/team/myTeam.vue